import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'
import Link from '../../atoms/link'

const mobileSlideWidth = ({ size }) => {
  switch (size) {
    case 'large':
      return 'min(13em, 41vw)'

    case 'extraSmall':
      return 'min(9.5em, 19vw)'

    case 'small':
    default:
      return 'min(10em, 28vw)'
  }
}
const gap = '0.75em'

export const StyledGamesCarouselWrapper = styled.div`
  position: relative;
  z-index: 0;

  h1,
  h2,
  h3,
  p,
  span {
    ${({ theme }) =>
      theme === 'light' &&
      css`
        color: ${themeStyles.colors.black.main};
      `}

    ${({ theme }) =>
      theme === 'dark' &&
      css`
        color: ${themeStyles.colors.white.main};
      `}

    ${({ theme }) =>
      theme === 'darkGrey9' &&
      css`
        color: ${themeStyles.colors.white.main};
      `}
  }

  &:before {
    z-index: -1;
    content: '';
    width: 100vw;
    height: calc(100% + 1em);
    background: ${themeStyles.dark};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    ${({ theme }) =>
      theme === 'light' &&
      css`
        background: ${themeStyles.colors.white.main};
      `}

    ${({ theme }) =>
      theme === 'dark' &&
      css`
        background: ${themeStyles.colors.black.main};
      `}

    ${({ theme }) =>
      theme === 'darkGrey9' &&
      css`
        background: ${themeStyles.colors.darkGreys[5].main};
      `}
  }

  padding-top: ${({ theme }) =>
    theme === 'light' || theme === 'darkGrey9' ? 0.5 : 0}em;

  &:first-child {
    ${({ theme }) =>
      theme === 'dark' &&
      css`
        padding-top: 0.5em;
      `}
  }
`

export const StyledOuterMobileWrapper = styled.div`
  overflow-x: scroll;
  padding-bottom: 0.5em;
`

export const StyledInnerMobileWrapper = styled.div`
  display: flex;

  width: calc(
    (${mobileSlideWidth} * ${(props) => props.length}) +
      (${gap}* ${(props) => props.length - 1})
  );
  gap: ${gap};

  > div {
    width: ${mobileSlideWidth};
    display: flex;
    flex-direction: column;
  }
`

export const StyledTitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    text-decoration: none;
  }

  ${({ theme }) =>
    theme === 'light' &&
    css`
      ${StyledTitle} {
        color: ${themeStyles.colors.black.main};
      }
      ${StyledSubtitle} {
        color: ${themeStyles.colors.primary.main};
      }
    `}
`

export const StyledDesktopWrapper = styled.div`
  ${StyledTitlesWrapper} {
    border-radius: 0;
    border: none;

    &:hover {
      border: none;
    }
  }
`

export const StyledSlide = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  padding: 0;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: 0.2s border;

  &:hover {
    border: 2px solid ${themeStyles.colors.white.main}4D;
  }
`

export const StyledImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
`

export const StyledTitle = styled.span`
  font-size: 0.95em;
  ${themeMedia.maxDesktop`
    font-size: 0.66em;
  `}

  line-height: 1.3em;
  padding: 0.3em 0 0.4em;
  color: ${themeStyles.colors.white.main};
`

export const StyledSubtitle = styled(Link)`
  font-size: 0.66em;
  text-transform: uppercase;
  color: ${themeStyles.colors.accentColors.secondary.main};
`

export const StyledFallbackOuterWrapper = styled.div`
  overflow-x: none;
  display: flex;
  flex-direction: column;
  gap: ${gap};
`

export const StyledFallbackInnerWrapper = styled.div`
  display: flex;
  gap: ${gap};
  ${themeMedia.maxDesktop`
    width: calc(calc(${mobileSlideWidth} + ${gap}) * 6);
  `}

  > div {
    display: flex;
    gap: 1px;
    flex-direction: column;
    width: calc(calc(${mobileSlideWidth} + ${gap}) * 6);
  }
`
